import { useNavigate } from "react-router-dom";

function MainComponent() {

    document.title = "お問い合わせ 受付完了| ファーストコンタクトセンター";
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/inquiry_status", { state: { page: true } })
    }

    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">
                <div className="str-inner">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <h2 className="mod-hdg-l2-02">
                        <span>お問い合わせ 受付完了</span>
                    </h2>

                    <div className="mod-txt">
                        <p>
                            現在、ご質問の受付処理を行っております。
                        </p>
                        <p>
                            受付処理終了後、貴殿宛てに登録完了のメールが送付され、メニュー画面よりお問い合わせのステータスの確認が可能となります。
                        </p>
                        <p>
                            続けてお問い合わせをされる場合は、お手数ですが、メニューよりお問い合わせフォームを開き直して下さい。
                            ブラウザの戻るボタンで戻った画面では、ご質問の登録が正常に処理されない場合がありますので、ご注意願います。
                        </p>
                    </div>

                    <div className="mod-btn of-list">
                        <div className="btn">
                            <button id="btn-go-top" className="of-left" onClick={goNext}>トップページへ</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default MainComponent;